import { render, staticRenderFns } from "./AdminAddOn.vue?vue&type=template&id=e21fcdf6&"
import script from "./AdminAddOn.vue?vue&type=script&lang=js&"
export * from "./AdminAddOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports